import React from "react"
import ReactDOM from "react-dom"
import AllowedItemsList from "./allowed-items-list-component"

export default class AllowedItemsListModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.mopinionId = elem.dataset.mopinionId && elem.dataset.mopinionId
    self.mopinionScript = elem.dataset.mopinionScript && elem.dataset.mopinionScript
    self.items = elem.dataset.items && JSON.parse(elem.dataset.items)
    self.popularItems = elem.dataset.popularItems && JSON.parse(elem.dataset.popularItems)
    self.remainingItems = elem.dataset.remainingItems && JSON.parse(elem.dataset.remainingItems)
    self.textKeys = elem.dataset.textKeys && JSON.parse(elem.dataset.textKeys)
    self.descriptionIcons = elem.dataset.descriptionIcons && JSON.parse(elem.dataset.descriptionIcons)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(
      <AllowedItemsList
        mopinionId={self.mopinionId}
        mopinionScript={self.mopinionScript}
        items={self.items}
        popularItems={self.popularItems}
        remainingItems={self.remainingItems}
        textKeys={self.textKeys}
        descriptionIcons={self.descriptionIcons}
      />,
      self.elem,
    )
  }
}
